export var ViewTrolleyProductListGroup;
(function (ViewTrolleyProductListGroup) {
    ViewTrolleyProductListGroup.CategoryTypeEnum = {
        Default: 'Default',
        OutOfStock: 'OutOfStock'
    };
})(ViewTrolleyProductListGroup || (ViewTrolleyProductListGroup = {}));
